////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'
import convertHexToRGBA from '../../../helpers/HexToRgba'

//////STYLED//////
const SalesByArticleHistoryStatusWrapper = styled.div`
	text-align: center;
	background-color: ${(props) => convertHexToRGBA(props.colorCode, 0.2)};
	color: ${(props) => props.colorCode};
	line-height: 32px;
	font-weight: bold;
	width: fit-content;
	padding: 0 10px;
	border-radius: 15px;
	margin: 0 auto;
	font-weight: bold;
`
//////STYLED//////

const SalesByArticleHistoryStatus = (props) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<SalesByArticleHistoryStatusWrapper colorCode={props.row.salesOrderStatus.colorCode}>
			{translations[props.row.salesOrderStatus.translationKey]}
		</SalesByArticleHistoryStatusWrapper>
	)
}

SalesByArticleHistoryStatus.propTypes = {}

SalesByArticleHistoryStatus.defaultPropTypes = {}

export default SalesByArticleHistoryStatus
